import * as ko from 'knockout';
import {Observable} from "~knockout/index";

var primaryScreen: Observable<string>,
    secondaryScreen: Observable<string>,
    screenParams: any;


/**
 * create bindings to control the active screen
 */
export function createScreenManagerBindings()
{
    primaryScreen = ko.observable();
    secondaryScreen = ko.observable();
}


/**
 * return the primary screen observable
 */
export function getPrimaryScreenObservable() : Observable<string>
{
    return primaryScreen;
}

/**
 * return the secondary screen observable
 */
export function getSecondaryScreenObservable() : Observable<string>
{
    return secondaryScreen;
}


/**
 * show a primary screen by id
 * @param screenId
 */
export function showPrimaryScreen(primaryID: string, params: any = null)
{
    //  when we change primary screens, hide any currently active secondary screens

    showSecondaryScreen(null);

    //  save screen params

    screenParams = params;

    //  set the new primary screen id

    primaryScreen(primaryID);
}


/**
 * show a secondary screen by id
 * @param screenId
 */
export function showSecondaryScreen(secondaryID: string)
{
    secondaryScreen(secondaryID);
}


/**
 * hide all secondary screens
 * @param screenId
 */
export function hideSecondaryScreens()
{
    secondaryScreen(null);
}


/**
 * get the currently active secondary screen
 */
export function getSecondaryScreen() : string
{
    return secondaryScreen();
}



//export function setScreenParams(params: any)
//{
//    screenParams =
//}

/**
 * get any params for the current screen
 * @returns {any}
 */
export function getScreenParams() : any
{
    return screenParams;
}


// WEBPACK FOOTER //
// ./src/ts/screens/ScreenManager.ts